import { useState, useEffect, memo } from 'react';

import type {
  AnyProgressSignal,
  VisibleProgressData,
} from '@frontend/controllers';
import { Box } from '@frontend/legacy-components';

type HasIsInitial = {
  isInitial?: boolean;
};

const LoadingIndicator = ({
  isInitial,
  loadingProgress,
  leftOffset,
}: HasIsInitial & {
  leftOffset?: string | number;
  loadingProgress: AnyProgressSignal;
}) => {
  const [visibleProgress, setVisibleProgress] =
    useState<VisibleProgressData>(null);

  useEffect(() => {
    if (loadingProgress) {
      return loadingProgress.subscribeIsLoadingVisible({
        next: setVisibleProgress,
        error: () => setVisibleProgress(null),
      }).unsubscribe;
    }
  }, [loadingProgress, setVisibleProgress]);

  if (visibleProgress) {
    const { description, percentage } = visibleProgress;
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        position="absolute"
        width="100%"
        zIndex={6}
        {...(!isInitial && { style: { bottom: '10px' } })}
      >
        <Box
          position="relative"
          height="25px"
          width={leftOffset ? `calc((100% - ${leftOffset}) * 0.8)` : '80%'}
          borderRadius="50px"
          border="1px solid #999"
          boxShadow="0 2px 10px rgba(0, 0, 0, 0.05)"
          margin="10px 0"
          padding="3px"
          background="#fff"
          {...(isInitial ? {} : { style: { margin: 0, width: '50%' } })}
        >
          <Box
            height="100%"
            borderRadius="inherit"
            transition="all 0.2s ease"
            background="linear-gradient(0deg, #1c679c, #108ee9)"
            width={`${percentage}%`}
          />
        </Box>
        <Box
          color="inherit"
          fontSize="16px"
          fontFamily="Libre Franklin"
          {...(!isInitial && { style: { fontSize: '12px' } })}
        >
          {description}
        </Box>
      </Box>
    );
  }
  return null; //no visible progress
};

export default memo(LoadingIndicator);
